import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button, Drawer, Empty } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import FloatingButton from "./FloatingButton";

const ToggleBtn = styled(FloatingButton)`
  top: 12px;
  right: 18px;
`;

const YearGroup = styled.div`
  margin-bottom: 1.5em;
`;

const YearLabel = styled.div`
  margin-bottom: 0.5em;
  color: #274863;
  font-weight: 600;
`;

const MonthBtn = styled(Button)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 0.4em;
    text-align: left;
  }
`;

const MonthCount = styled.span`
  color: #999;
`;

// 依 "YYYY-MM" 的年份分組，年份新到舊、組內月份維持 server 回傳的新到舊排序。
function groupByYear(months) {
  return months.reduce((groups, entry) => {
    const year = entry.month.slice(0, 4);

    return {
      ...groups,
      [year]: [...(groups[year] || []), entry],
    };
  }, {});
}

export default function SpendingOutliner({ months, activeMonth, onSelectMonth }) {
  const [open, setOpen] = useState(false);

  const monthsByYear = useMemo(() => groupByYear(months), [months]);
  const years = Object.keys(monthsByYear).sort((a, b) => b.localeCompare(a));

  const handleSelect = (month) => {
    onSelectMonth(month);
    setOpen(false);
  };

  return (
    <>
      <ToggleBtn
        onClick={() => setOpen(true)}
        icon={<HistoryOutlined />}
        aria-label="快轉到早期紀錄"
      />

      <Drawer title="快轉到月份" placement="right" onClose={() => setOpen(false)} open={open}>
        {activeMonth && (
          <Button
            block
            type="link"
            onClick={() => handleSelect(null)}
            style={{ marginBottom: "1em" }}
          >
            回到最新
          </Button>
        )}

        {years.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}

        {years.map((year) => (
          <YearGroup key={year}>
            <YearLabel>{year}</YearLabel>

            {monthsByYear[year].map(({ month, count }) => (
              <MonthBtn
                key={month}
                type={month === activeMonth ? "primary" : "default"}
                onClick={() => handleSelect(month)}
              >
                <span>{month}</span>
                <MonthCount>{count} 筆</MonthCount>
              </MonthBtn>
            ))}
          </YearGroup>
        ))}
      </Drawer>
    </>
  );
}

SpendingOutliner.propTypes = {
  months: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  activeMonth: PropTypes.string,
  onSelectMonth: PropTypes.func.isRequired,
};

SpendingOutliner.defaultProps = {
  activeMonth: null,
};
